import { render, staticRenderFns } from "./DebtCard.vue?vue&type=template&id=4b1ed72c&scoped=true"
import script from "./DebtCard.vue?vue&type=script&lang=js"
export * from "./DebtCard.vue?vue&type=script&lang=js"
import style0 from "./DebtCard.vue?vue&type=style&index=0&id=4b1ed72c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1ed72c",
  null
  
)

export default component.exports